import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid } from "@mui/material"
import { StatsLabels } from "locale/es";
import { useSelector } from 'react-redux'
import { isEmptyObj } from "utils/HelperFunctions";
import { faFire } from "@fortawesome/free-solid-svg-icons";
import PerHourTotalInDay from "./PerHourTotalInDay";
import SectionHeader from "../SectionHeader";

const CaloriesStats = () => {
  const patientId = useSelector(({ patient }) => patient.id)

  // TODO: Both chart components code is identical except for the states and methods they use. Create a custom hook
  return (
    <>
      {!isEmptyObj(patientId) &&
        <Grid container justifyContent='center' spacing={2} >
          <SectionHeader sectionTitle={StatsLabels.CALORIES} >
            <FontAwesomeIcon icon={faFire} size='2xl' style={{ marginBottom: 16, marginLeft: 8 }} />
          </SectionHeader>
          <Grid item >
            <PerHourTotalInDay />
          </Grid>
        </Grid >
      }
    </>
  )
}

export default CaloriesStats